const colorList = ['#f56a00', '#7265e6', '#ffbf00', '#00a2ae', '#00c49f', '#ff6590', '#0088fe', '#9575de', '#ffbb28', '#3aa1ff'];

export const defaultColors = ['rgba(220, 20, 60, .2)', 'rgba(34, 139, 34, .2)', 'rgba(172, 152, 38, .2)', 'rgba(0, 191, 255, .2)', 'rgba(165, 42, 42, .2)',
    'rgba(202, 115, 129, .2)', 'rgba(216, 112, 147, .2)', 'rgba(128, 0, 128, .2)',
    'rgba(65, 105, 225, .2)', 'rgba(71, 128, 163, .2)', 'rgba(72, 165, 134, .2)', 'rgba(119, 168, 44, .2)', 'rgba(32, 118, 139, .2)',
    'rgba(147, 112, 216, .2)', 'rgba(30, 144, 255, .2)',
    'rgba(82, 179, 82, .2)', 'rgba(160, 82, 45, .2)']

const getHashCode = (str, caseSensitive) => {
    if (!caseSensitive) {
        str = str.toLowerCase();
    }
    // 1315423911=b'1001110011001111100011010100111'
    var hash = 1315423911, i, ch;
    for (i = str.length - 1; i >= 0; i--) {
        ch = str.charCodeAt(i);
        hash ^= ((hash << 5) + ch + (hash >> 2));
    }

    return (hash & 0x7FFFFFFF);
};


const getRandomColor = (key) => {
    if (!key)
        key = " ";

    let index = getHashCode(key) % colorList.length;
    return colorList[index];
};

const getRandomColorOpacityDot2 = (key) => {
    if (!key)
        key = " ";

    let index = getHashCode(key) % defaultColors.length;
    return defaultColors[index];
};

export { getRandomColor, getRandomColorOpacityDot2 };